<template>
  <div class="event-tab">
    <EmailDialog
      v-if="is_visible.delete_event_dialog"
      :is_visible="is_visible.delete_event_dialog"
      :candidateId="candidateId"
      title="Удалить встречу?"
      :confirmDeleteMeeting="true"
      @confirm="deleteEvent"
      :width="deleteDialogWidth"
      @reset-callback="is_visible.delete_event_dialog = false"
    />
    <SubpanelTable
      v-if="tableTitle && tableList && tableList.length"
      :tableColumns="tableTitle"
      :tableData="tableList"
      @handleDelete="openDeleteDialog"
      @rowClick="openEventDialog"
      subpanelName="event"
      :style="tableHeight"
    ></SubpanelTable>
    <div v-else>
      <Alert text="Событий еще нет" />
    </div>
  </div>
</template>
<script>
import { mixin, errorMsg } from '@/utils/mixins';
import SubpanelTable from 'Elements/Table/SubpanelTable';
import Alert from 'Elements/Alert/Alert';
import { store } from '@/store';
import { getController } from '@/controllers/request.js';
import EmailDialog from 'Elements/Dialog/EmailDialog';
import { DIALOG_WIDTH } from '@/utils/constants';

export default {
  mixins: [mixin, errorMsg],
  props: {
    metadata: [Array, Object]
  },
  data() {
    return {
      tableTitle: null,
      tableList: null,
      is_visible: {
        delete_event_dialog: false
      },
      delete_params: {},
      candidateId: '',
      deleteDialogWidth: null
    };
  },
  created() {
    if (this.metadata.data && this.metadata.data.title) {
      this.tableTitle = this.metadata.data.title;
    }
    if (this.metadata.data && this.metadata.data.List) {
      this.tableList = this.metadata.data.List;
    }
  },

  methods: {
    openEventDialog(item) {
      store.commit('candidate/setSelectedMeeting', item);
      store.commit('common/setVisibleDialog', {
        name: 'event_view_dialog',
        val: true
      });
    },
    async openDeleteDialog(row) {
      if (row.delete?.intent?.request) {
        try {
          this.deleteDialogWidth =
            DIALOG_WIDTH[row.delete?.intent.size] || DIALOG_WIDTH.S;

          const response = await getController({
            params: row.delete.intent.request.request_params,
            url: row.delete.intent.request.url
          });
          if (response && response.data) {
            this.delete_params = response.data;
            this.candidateId =
              row.delete.intent.request.request_params.candidate_id;
            this.$set(this.is_visible, 'delete_event_dialog', true);
          }
        } catch (err) {
          this.catchError(
            err,
            'Возникла ошибка при завершении импорта',
            'upload file'
          );
        }
      }
    },
    async deleteEvent() {
      if (
        this.delete_params?.metadata?.buttons_menu &&
        this.delete_params.metadata.buttons_menu[0]
      ) {
        for (let i in this.delete_params.metadata.buttons_menu[0]) {
          if (this.delete_params.metadata.buttons_menu[0][i].name == 'delete') {
            const deleteIntens =
              this.delete_params.metadata.buttons_menu[0][i].intents;
            try {
              await getController({
                params: deleteIntens[1].request.request_params,
                url: deleteIntens[1].request.url
              });
            } catch (err) {
              console.error(
                err,
                'Возникла ошибка при завершении импорта',
                'upload file'
              );
            }
          }
        }
      }

      this.$set(this.is_visible, 'delete_event_dialog', false);
      this.$emit('reloadTab');
    }
  },
  computed: {
    tableHeight() {
      return `min-height: ${52 + (this.tableList?.length || 0) * 48.8}px`;
    }
  },
  components: {
    SubpanelTable,
    Alert,
    EmailDialog
  }
};
</script>

<style lang="scss" scoped>
.event-tab {
  padding: 16px 24px 24px;
  background: $white;
  border-radius: 4px;
}
</style>
